import React, { useContext } from 'react'
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

function EstimatedDelivery(props) {
  const { currentVariant } = useContext(ConfiguratorContext)

  const estimated_delivery = currentVariant.estimated_delivery ?? ''

  if (estimated_delivery.length <= 0) return null

  return (
    <>
      <p className='config-overview__car-delivery'>{estimated_delivery}</p>
    </>
  )
}

export default EstimatedDelivery
